import { h } from 'preact';
import { BalanceIndicator } from '../BalanceIndicator';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'BalanceIndicator',
  category: '🏷️ Badges & Indicadores',
  description: 'Saldo com cor dinâmica baseada no valor',
  usedIn: ['ChatHubPage', 'DashboardPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <BalanceIndicator value={25.50} />
      <BalanceIndicator value={3.20} />
      <BalanceIndicator value={0.50} />
      <BalanceIndicator value={null} size="sm" />
    </div>
  ),
};
